import {
  NOTIFICATION_BELL_DATA,
  NOTIFICATION_BELL_DATA_UPDATE,
  NOTIFICATION_BELL_FETCHING,
  READ_ALL_NOTIFICATIONS,
} from '@constants/actionTypes';
import { axiosHelper } from '@root/services/axios';

// Store WebSocket instance globally to prevent creating multiple connections
let notificationSocketInstance = null;

// Reset function to allow fresh notification fetch on next login
export const resetNotificationFetchState = () => {
  notificationSocketInstance = null;
};

export const fetchNotificationlistData = async (dispatch, page, onlyUnread, mark_all_read) => {
  // Set fetching flag to true
  dispatch({
    type: NOTIFICATION_BELL_FETCHING,
    payload: true,
  });

  const notificationList = await axiosHelper.axiosPost(
    'notification_bellicon_list',
    { data: { status: onlyUnread ? false : 'All', ...(mark_all_read && { mark_all_read: true }) } },
    false,
    page,
  );

  // Only create WebSocket connection once, reuse for subsequent calls
  if (!notificationSocketInstance || notificationSocketInstance.readyState === WebSocket.CLOSED) {
    notificationSocketInstance = new WebSocket(`${import.meta.env.VITE_WEBSOCKET_NOTIFICATION}`);

    notificationSocketInstance.onopen = () => {
      console.log('Notification socket connected!');
    };

    notificationSocketInstance.onmessage = params => {
      try {
        let responseData = JSON.parse(params['data']);
        dispatch({
          type: NOTIFICATION_BELL_DATA_UPDATE,
          payload: responseData,
        });
      } catch (error) {
        console.error('Error parsing WebSocket notification data:', error);
      }
    };

    notificationSocketInstance.onerror = error => {
      console.error('Notification WebSocket error:', error);
    };

    notificationSocketInstance.onclose = () => {
      console.log('Notification socket disconnected');
      notificationSocketInstance = null;
    };
  }

  dispatch({
    type: NOTIFICATION_BELL_DATA,
    payload: notificationList,
  });

  if (mark_all_read) {
    dispatch({
      type: READ_ALL_NOTIFICATIONS,
      payload: notificationList,
    });
  }

  return notificationList;
};

// Cleanup function to close WebSocket connection
export const closeNotificationSocket = () => {
  if (notificationSocketInstance && notificationSocketInstance.readyState === WebSocket.OPEN) {
    notificationSocketInstance.close();
    notificationSocketInstance = null;
    console.log('Notification socket closed manually');
  }
};

export const logoutApi = async (dispatch, data) => {
  // Close WebSocket connection on logout
  closeNotificationSocket();
  // Reset notification fetch state to allow fresh fetch on next login
  resetNotificationFetchState();
  const logout = await axiosHelper.axiosPost('logout', { data }, false);
  return logout;
};
